export var Mode;
(function (Mode) {
    Mode["AT_HOME"] = "AT_HOME";
    Mode["AT_SCHOOL"] = "AT_SCHOOL";
    Mode["SSO"] = "SSO";
    Mode["UNKNOWN"] = "UNKNOWN";
})(Mode || (Mode = {}));
export var HomeCodeStatus;
(function (HomeCodeStatus) {
    HomeCodeStatus["SENT"] = "SENT";
    HomeCodeStatus["USED"] = "USED";
})(HomeCodeStatus || (HomeCodeStatus = {}));
export const RECOMMENDED_USAGE_PER_WEEK_IN_MINUTES = 30;
export var FoundationalVocabularyStatus;
(function (FoundationalVocabularyStatus) {
    FoundationalVocabularyStatus["NONE"] = "NONE";
    FoundationalVocabularyStatus["ONGOING"] = "ONGOING";
    FoundationalVocabularyStatus["CANCELED"] = "CANCELED";
    FoundationalVocabularyStatus["COMPLETED"] = "COMPLETED";
})(FoundationalVocabularyStatus || (FoundationalVocabularyStatus = {}));
//# sourceMappingURL=student.js.map